<template>
    <div class="flex items-center justify-center papsi-keypad-full" >
        <div class="flex flex-col">
            <div class="flex flex-row items-center justify-center">
                <span v-if="input_type === 'mobile'" class="flex flex-row items-center justify-center mt-12 mobile" >
                    <span class="mr-5 font-bold text-black text-6xl border-b-4 border-white number" style="letter-spacing: 0.5rem;">+63</span>
                    <span 
                        v-for="(digit, index) in padded_digits" 
                        :key="index" 
                        :style="{ height: '5rem', marginRight: (index === 2 || index === 5) ? '2rem' : '0.5rem' }" 
                        class="border-b-4 border-grey-light font-bold text-black text-6xl flex items-center justify-center">
                        <p class="digit" style="width: 33px;">{{ digit }}</p>
                    </span>
                </span>
                <span v-else-if="input_type === 'TIN'" class="flex flex-row items-center justify-center mt-5" >
                    <span 
                        v-for="(digit, index) in padded_digits" 
                        :key="index" 
                        :style="{ height: '5rem', marginRight: (index === 2 || index === 5) ? '2rem' : '0.5rem' }" 
                        class="border-b-4 border-grey-light font-bold text-black text-6xl flex items-center justify-center">
                        <p class="digit" style="width: 35px;">{{ digit || '' }}</p>
                    </span>
                </span>

                <span v-else-if="input_type === 'PIN'" class="flex flex-row items-center justify-between mt-12 papsi-placeholder" style="width: 580px;">
                    <span v-for="(digit, index) in padded_digits" :key="index" style="width: 5rem; height: 6rem;" class="bg-grey-lighter rounded-xl font-bold text-black text-7xl flex items-center align-center justify-center w-24 h-24 papsi-placeholder-span">
                        {{ isAsterisk(index) ? '*' : digit }}
                    </span>
                </span>
                <span v-else class="flex flex-row items-center justify-between mt-12 papsi-placeholder" style="width: 580px;">
                    <span v-for="(digit, index) in padded_digits" :key="index" style="width: 5rem; height: 6rem;" class="bg-grey-lighter rounded-xl font-bold text-black text-7xl flex items-center align-center justify-center w-24 h-24 papsi-placeholder-span">
                        {{ digit }}
                    </span>
                </span>
            </div>

            <div class="rounded-lg mt-10 papsi-keypad" style="width: 600px; height: 400px">
                <div class="flex flex-col">
                    <div v-for="(row, row_index) in button_rows" :key="row_index" class="flex flex-row items-center justify-center">
                        <ButtonControl v-for="(button, button_index) in row" :key="button_index"
                            :icon_id="button === 'Back' ? 'back_white' : ''"
                            :icon_height="button === 'Back' ? 20 : 0" :icon_width="button === 'Back' ? 20 : 0"
                            :theme="button === 'Clear' ? 'delete' : button === 'Back' ? 'clear' : 'keypad'"
                            :text="button" style="height: 75px; width: 190px;" @click="handleButtonClick(button)" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonControl from './ButtonControl.vue';

export default {
    name: 'v-keypad',
    components: {
        ButtonControl,
    },
    props: {
        input_type: {
            type: String,
            required: true,
            default: 'PIN',
            validator: (value) => ['PIN', 'OTP', 'mobile', 'TIN'].includes(value),
        },
        limit: {
            type: Number,
            default: 6,
        },
    },
    data() {
        return {
            beep: new Audio('https://resource.pafcpic.net/assets/pia/sounds/papsi_beep.mp3'),
            button_rows: [
                ['1', '2', '3'],
                ['4', '5', '6'],
                ['7', '8', '9'],
                ['Clear', '0', 'Back']
            ],
            saved_digits: [],
            asterisk_digits: [],
            is_full: false, // To track if the digits are full
            keypad_delay: parseInt(process.env.VUE_APP_KEYPAD_DELAY, 10),
        };
    },
    computed: {
        padded_digits() {
            return [...this.saved_digits, ...Array(this.limit - this.saved_digits.length).fill('')];
        }
    },
    methods: {
        playBeep() {
            this.beep.play();
        },
        handleButtonClick(button) {
            this.playBeep();
            if (button === 'Back') {
                this.deleteDigit();
            } else if (button === 'Clear') {
                this.clearDigits();
            } else {
                this.saveDigit(button);
            }
        },
        saveDigit(digit) {
            if (this.saved_digits.length < this.limit) {
                this.saved_digits.push(digit);
                this.$emit('digits-changed', this.saved_digits);

                // If digits are full, add a delay before emitting 'digits-full'
                if (this.saved_digits.length === this.limit && !this.is_full) {
                    this.is_full = true;

                    // Delay the full event emission
                    setTimeout(() => {
                        this.$emit('digits-full', this.saved_digits);
                    }, this.keypad_delay); // delay before emitting 'digits-full'
                }

                // Add a delay to replace the digit with an asterisk
                setTimeout(() => {
                    this.asterisk_digits.push(true); // Mark as asterisk
                }, this.keypad_delay); // delay to simulate the change
            }
        },
        
        clearDigits() {
            this.saved_digits = [];
            this.asterisk_digits = [];
            this.is_full = false; // Reset is_full when clearing digits
            this.$emit('digits-cleared');
        },
        deleteDigit() {
            this.saved_digits.pop();
            this.asterisk_digits.pop();
            this.is_full = false; // Reset is_full if deleting digits
            this.$emit('digits-changed', this.saved_digits);
        },
        isAsterisk(index) {
            return this.asterisk_digits[index];
        }
    }
};
</script>

<style scoped>
@media only screen and (min-width: 2500px) {
    .papsi-placeholder {
        width: 60rem !important;
    }

    .papsi-placeholder-span {
        width: 8rem !important;
        height: 8rem !important;
    }

    .papsi-keypad-full {
        margin-top: -15rem !important;
        margin-bottom: 15rem !important;
        height: 60rem !important;
    }

    .papsi-keypad {
        width: 60rem !important;
        height: 8rem !important;
    }

    .mobile {
        width: 60rem !important;
    }

    .digit {
        width: 65px !important;
        font-size: 4.5rem !important;
        padding-bottom: 2rem !important;
    }

    .number {
        font-size: 4.5rem !important;
        padding-bottom: 2rem !important;
    }
}
</style>
